
// fix html order for accessibility reasons
//first Klaro, then overlay, then navigation
$(document).ready(function() {
    const overlayContainer = $('.overlay').detach();
    const klaroContainer = $('#klaro').detach();
    $('body').prepend(overlayContainer).prepend(klaroContainer);
});
